import { PayPalScriptProvider } from '@paypal/react-paypal-js';

const PayPalProvider = ({ children }) => {
  const initialOptions = {
    "client-id": import.meta.env.VITE_PAYPAL_CLIENT_ID,
    currency: "USD",
    intent: "capture",
    components: "buttons",
    "enable-funding": "paypal,card",
    "disable-funding": "paylater,credit"
  };

  if (!import.meta.env.VITE_PAYPAL_CLIENT_ID) {
    console.error('PayPal client ID is not configured. Please check your environment variables.');
    return (
      <div className="w-full p-4 bg-red-50 border border-red-200 rounded-lg text-center">
        <p className="text-red-600">Payment system is currently unavailable. Please try again later.</p>
      </div>
    );
  }

  return (
    <PayPalScriptProvider options={initialOptions}>
      {children}
    </PayPalScriptProvider>
  );
};

export default PayPalProvider; 